import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Default colors for pie slices
const DEFAULT_COLORS = [
    "#3b82f6", // blue
    "#22c55e", // green
    "#eab308", // yellow
    "#ef4444", // red
    "#8b5cf6", // purple
    "#06b6d4", // cyan
    "#f97316", // orange
    "#ec4899", // pink
];
export function PieChart({ data, title, size = 200 }) {
    if (!data || data.length === 0) {
        return (_jsx("div", { className: "soroban-chart soroban-chart-pie", style: { textAlign: "center", padding: "1rem" }, children: _jsx("p", { style: { color: "#666" }, children: "No data available" }) }));
    }
    const total = data.reduce((sum, d) => sum + d.value, 0);
    if (total === 0) {
        return (_jsx("div", { className: "soroban-chart soroban-chart-pie", style: { textAlign: "center", padding: "1rem" }, children: _jsx("p", { style: { color: "#666" }, children: "No data to display" }) }));
    }
    const radius = size / 2;
    const center = radius;
    // Calculate pie slices
    let currentAngle = -90; // Start from top
    const slices = data.map((point, index) => {
        const percentage = point.value / total;
        const angle = percentage * 360;
        const startAngle = currentAngle;
        const endAngle = currentAngle + angle;
        currentAngle = endAngle;
        const color = point.color || DEFAULT_COLORS[index % DEFAULT_COLORS.length];
        return {
            ...point,
            startAngle,
            endAngle,
            percentage,
            color,
        };
    });
    // Convert angle to SVG arc coordinates
    const polarToCartesian = (cx, cy, r, angleDeg) => {
        const angleRad = (angleDeg * Math.PI) / 180;
        return {
            x: cx + r * Math.cos(angleRad),
            y: cy + r * Math.sin(angleRad),
        };
    };
    const createArcPath = (cx, cy, r, startAngle, endAngle) => {
        const start = polarToCartesian(cx, cy, r, startAngle);
        const end = polarToCartesian(cx, cy, r, endAngle);
        const largeArcFlag = endAngle - startAngle > 180 ? 1 : 0;
        return [
            "M", cx, cy,
            "L", start.x, start.y,
            "A", r, r, 0, largeArcFlag, 1, end.x, end.y,
            "Z",
        ].join(" ");
    };
    return (_jsxs("div", { className: "soroban-chart soroban-chart-pie", children: [title && (_jsx("h4", { style: { margin: "0 0 0.75rem 0", fontSize: "1rem", fontWeight: 600, textAlign: "center" }, children: title })), _jsxs("div", { style: { display: "flex", alignItems: "center", gap: "1.5rem", justifyContent: "center", flexWrap: "wrap" }, children: [_jsx("svg", { width: size, height: size, viewBox: `0 0 ${size} ${size}`, children: slices.map((slice, index) => (_jsx("path", { d: createArcPath(center, center, radius - 2, slice.startAngle, slice.endAngle), fill: slice.color, stroke: "white", strokeWidth: "2", children: _jsx("title", { children: `${slice.label}: ${slice.value} (${(slice.percentage * 100).toFixed(1)}%)` }) }, index))) }), _jsx("div", { className: "soroban-chart-legend", style: { display: "flex", flexDirection: "column", gap: "0.5rem" }, children: slices.map((slice, index) => (_jsxs("div", { style: { display: "flex", alignItems: "center", gap: "0.5rem", fontSize: "0.875rem" }, children: [_jsx("div", { style: {
                                        width: "12px",
                                        height: "12px",
                                        borderRadius: "2px",
                                        backgroundColor: slice.color,
                                        flexShrink: 0,
                                    } }), _jsxs("span", { style: { color: "#374151" }, children: [slice.label, ": ", slice.value, " (", (slice.percentage * 100).toFixed(1), "%)"] })] }, index))) })] })] }));
}
//# sourceMappingURL=PieChart.js.map